import { render, staticRenderFns } from "./scanManageTemplate.vue?vue&type=template&id=60a32ad4&scoped=true&"
import script from "./scanManageTemplate.vue?vue&type=script&lang=js&"
export * from "./scanManageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a32ad4",
  null
  
)

export default component.exports